var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"color":"primary","nuxt":"","to":{name: 'home'}}},[_vm._v("\n        "+_vm._s(_vm.$t('book_other_services'))+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }